import { axInst } from "../Login/Service.jsx";

//region
export const fetchRegion = async () => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: [],
    state: [],
    state_office: [],
    Partner_Type: [],
    Category: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });

  const regionsArray = data?.REGION.buckets.map((e) => e.key);
  const sortedRegionArray = regionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );
  return sortedRegionArray;
};

//state
export const fetchStates = async (pRegion) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: [],
    state_office: [],
    Partner_Type: [],
    Category: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });
  const statesArray = data?.STATE.buckets.map((e) => e.key);
  const sortedStatesArray = statesArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedStatesArray;
};

//stateoffice
export const fetchStatesOffice = async (pRegion, pState) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: [],
    Partner_Type: [],
    Category: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });
  const statesOfficeArray = data?.SSO.buckets.map((e) => e.key);
  const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedStatesOfficeArray;
};

export const fetchRsm = async (pRegion, pState, pStateOffice) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: [],
    Partner_Type: [],
    Category: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });
  const rsmArray = data?.RSM.buckets.map((e) => e.key);
  const sortedRsmArray = rsmArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedRsmArray;
};

export const fetchPartnerType = async (pRegion, pState, pStateOffice, pRsm) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: [],
    Category: [],
    dealer_name: [],
    division_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });

  const PartnerTypeArray = data?.PARTNER_TYPE.buckets.map((e) => e.key);
  const sortedPartnerTypeArray = PartnerTypeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedPartnerTypeArray;
};

export const fetchDealerTag = async (
  pRegion,
  pState,
  pStateOffice,
  pRsm,
  pPartnerType,
) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: pPartnerType || [],
    Category: [],
    dealer_name: [],
    division_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });

  const dealerTagArray = data?.DEALER_TAG.buckets.map((e) => e.key);
  const sortedDealerTagArray = dealerTagArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedDealerTagArray;
};

//DealerName
export const fetchDealer = async (
  pRegion,
  pState,
  pStateOffice,
  pRsm,
  pPartnerType,
  pDealerTag,
) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: pPartnerType || [],
    Category: pDealerTag || [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });
  const DealerArray = data?.DEALER_NAME.buckets.map((e) => e.key);
  const sortedDealerArray = DealerArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedDealerArray;
};

//DealerCode
export const fetchDealercode = async (
  pRegion,
  pState,
  pStateOffice,
  pRsm,
  pPartnerType,
  pDealerTag,
  pDealer,
) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: pPartnerType || [],
    Category: pDealerTag || [],
    dealer_name: pDealer || [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });
  const dealercodeArray = data?.DEALER_CODE.buckets.map((e) => e.key);
  const sorteddealercodeArray = dealercodeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sorteddealercodeArray;
};

export const fetchDivision = async (
  pRegion,
  pState,
  pStateOffice,
  pRsm,
  pPartnerType,
  pDealerTag,
  pDealer,
  pDealerCode,
) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: pPartnerType || [],
    Category: pDealerTag || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });
  const DivisionArray = data?.DIVISION.buckets.map((e) => e.key);
  const sortedDivisionArray = DivisionArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedDivisionArray;
};

export const fetchProductLine = async (
  pRegion,
  pState,
  pStateOffice,
  pRsm,
  pPartnerType,
  pDealerTag,
  pDealer,
  pDealerCode,
  pDivision,
) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: pPartnerType || [],
    Category: pDealerTag || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
  });
  const productLineArray = data?.Product_Line.buckets.map((e) => e.key);

  const sortedProductLineArray = productLineArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );
  return sortedProductLineArray;
};

//Lob
export const fetchLOB = async (
  pRegion,
  pState,
  pStateOffice,
  pRsm,
  pPartnerType,
  pDealerTag,
  pDealer,
  pDealerCode,
  pProductLine,
  pDivision,
) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: pPartnerType || [],
    Category: pDealerTag || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: [],
    ppl: [],
    pl: [],
  });

  const lobArray = data?.LOB.buckets.map((e) => e.key);
  const sortedLobArray = lobArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedLobArray;
};

export const fetchPPL = async (
  pRegion,
  pState,
  pStateOffice,
  pRsm,
  pPartnerType,
  pDealerTag,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine,
  pLob,
) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: pPartnerType || [],
    Category: pDealerTag || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: [],
    pl: [],
  });
  const pplArray = data?.PPL.buckets.map((e) => e.key);
  const sortedPPLArray = pplArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );
  return sortedPPLArray;
};

//pl
export const fetchPL = async (
  pRegion,
  pState,
  pStateOffice,
  pRsm,
  pPartnerType,
  pDealerTag,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine,
  pLob,
  pPpl,
) => {
  const { data } = await axInst.post("collbax-service/collbax_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    rsm: pRsm || [],
    Partner_Type: pPartnerType || [],
    Category: pDealerTag || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: [],
  });
  const plArray = data?.PL.buckets.map((e) => e.key);
  const sortedPLArray = plArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );
  return sortedPLArray;
};
